<template>

    <b-container style="flex: available">
        <b-container style="margin: 15px">
          <p>Thank you for your interest in becoming a RISE GREEN or NAPA GREEN CERTIFIED CLIMATE-SMART WINERY.
            We work hand in hand with our members to take a whole system approach to sustainability and climate
            action across our <a href="https://napagreen.org/six-pillars/">
              "SIX PILLARS OF SUSTAINABLE WINEGROWING LEADERSHIP".</a></p>

          <p>Napa Green Wineries implement >140 leading practices, improving resource efficiency and saving $$,
            cutting carbon footprint, greening purchasing, and engaging teams. Critically, RISE GREEN and
            NAPA GREEN Wineries track their performance, to ensure these practices are achieving real results
                and continuing improvement over time.</p>

          <p>Uniquely, our nonprofit has an expert team that will work with you closely throughout the certification
            process.
            There is a $250 application fee, which will cover the time to onboard your team and ensure they understand
            the steps to certification,
                including the value-add Integrated Resource Assessment. We are always available to answer questions – please reach out to winery@napagreen.org.</p>

          <p>Once you fill out and submit the information below you will be sent an email with your username and
                temporary password to access the Winery Certification Portal.</p>


            <p><span style="font-style: italic">Note: This information is kept confidential.</span></p>


        </b-container>
        <b-container>
            <span style="margin-top: 10px"><br/></span>
            <b-container fluid>
                <b-container fluid>
                    <b-card bg-variant="light">

                        <b-form-group
                                label-cols-sm="4"
                                label="Winery Name*:"
                                label-align-sm="left"
                                label-for="nested-street"
                        >
                            <b-form-input id="nested-company-name" size="sm" v-model="businessName"
                                          placeholder="Winery Name"/>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-size="md"
                                label="Winery Address*:"
                                label-align-sm="left"
                                label-for="nested-street"
                        >
                            <b-form-input id="nested-street" size="sm" v-model="businessAddress"
                                          placeholder="Winery Address"/>
                        </b-form-group>


                        <b-form-group
                            label-cols="4"
                            label-cols-lg="4"
                            label-size="md"
                            label="County*:"
                            label-for="input-sm">
                        <b-form-select
                            v-model="county"
                            :options="countyMap">
                        </b-form-select>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Contact Name*: (Someone familiar with the winery operation and facility)"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="contactName"
                                          placeholder="Contact Name"/>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Contact Title: "
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="contactTitle"
                                          placeholder="Contact Title"/>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Contact Phone Number*:"
                                label-for="input-sm">
                            <b-form-input id="telephoneNumber" size="sm"
                                          v-model="contactTelephoneNumber" placeholder="Contact Phone Number"/>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Contact Email Address*:"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="contactEmail"
                                          placeholder="Contact Email"/>
                        </b-form-group>


                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Owner/Leadership Name*: "
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="ownerName"
                                          placeholder="Owner/Leadership Name"/>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Owner/Leadership Phone Number:"
                                label-for="input-sm">
                            <b-form-input id="telephoneNumber" size="sm"
                                          v-model="ownerTelephoneNumber"
                                          placeholder="Owner/Leadership Telephone Number"/>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Owner/Leadership Email Address*:"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="ownerEmail"
                                          placeholder="Owner/Leadership Email"/>
                        </b-form-group>
                      <b-form-group
                          label-cols="4"
                          label-cols-lg="4"
                          label-size="md"
                          label="Accountant Name*: "
                          label-for="input-sm">
                        <b-form-input id="input-sm" size="sm" v-model="accountantName"
                                      placeholder="Accountant Name"/>
                      </b-form-group>

                      <b-form-group
                          label-cols="4"
                          label-cols-lg="4"
                          label-size="md"
                          label="Accountant Email Address*:"
                          label-for="input-sm">
                        <b-form-input id="input-sm" size="sm" v-model="accountantEmail"
                                      placeholder="Accountant Email"/>
                      </b-form-group>

                      <b-form-group
                          label-cols="4"
                          label-cols-lg="4"
                          label-size="md"
                          label="Communications/Marketing Contact:"
                          label-for="input-sm">
                        <b-form-input id="input-sm" size="sm" v-model="communicationsContact"
                                      placeholder="Communications/Marketing Contact"/>
                      </b-form-group>

                      <b-form-group
                          label-cols="4"
                          label-cols-lg="4"
                          label-size="md"
                          label="Communications/Marketing Email:"
                          label-for="input-sm">
                        <b-form-input id="input-sm" size="sm" v-model="communicationsContactEmail"
                                      placeholder="Communications/Marketing Email"/>
                      </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Waste/Recycling/Compost Service Provider Name(s):"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="wasteProvider"
                                          placeholder="Waste Provider"/>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Water Supply Source: (Well/Municipal)"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="waterSupplySource"
                                          placeholder="Water Supply Source"/>
                        </b-form-group>

                        <b-container fluid>

                            <b-form-group
                                    label="Do you have water flow meter(s) that allows you to track process, admin, hospitality and decorative landscaping usage (whether in total or separately)? (If no, we can assist with this).">
                                <b-form-radio-group
                                        v-model="trackableWaterMeter"
                                        :options="yesNoOptions"
                                        name="waterMeterTracking"
                                        stacked
                                />
                            </b-form-group>


                            <b-form-group
                                    label="Have you had a CLEAResult Wine Industry Efficiency Solutions (WIES) audit in the past 5 years?">
                                <b-form-radio-group
                                        v-model="wiesSelected"
                                        :options="yesNoOptions"
                                        name="clearResult   "
                                        stacked
                                />
                            </b-form-group>

                            <b-form-group label="Renewable Energy (Check those that apply):">
                                <b-form-checkbox-group
                                        v-model="renewableEnergySelected"
                                        :options="renewableEnergyOptions"
                                        name="renewableEnergyInstalled"
                                        stacked
                                />
                            </b-form-group>
                            <b-form-group label="EV Charging Station(s):">
                                <b-form-radio-group
                                        v-model="evChargingStations"
                                        :options="yesNoOptions"
                                        name="flavour-2a"
                                        stacked
                                />
                            </b-form-group>

                            <b-form-group label="Other Environmental Certification (check those that apply):">
                                <b-form-checkbox-group
                                        v-model="environmentalCertifications"
                                        :options="environmentalCertificationsOptions"
                                        name="environmentalCertifications"
                                        stacked
                                />
                            </b-form-group>
                            <b-form-group label="Please indicate if you have the following features:">
                                <b-form-checkbox-group
                                        v-model="featuresSelected"
                                        :options="featuresOptions"
                                        name="flavour-2a"
                                        stacked
                                />
                            </b-form-group>
                            <b-form-group label="Wastewater Treatment (Check relevant): ">
                                <b-form-checkbox-group
                                        v-model="wasteWaterSelected"
                                        :options="wasteWaterTreatmentOptions"
                                        name="flavour-2a"
                                        stacked
                                />
                            </b-form-group>
                        </b-container>

                        <div class="button-holder">
                            <b-row align-h="center">
                                <b-col cols="2"/>
                                <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                                    form.
                                </b-col>
                                <b-col cols="2"/>
                            </b-row>
                        </div>

                        <div class="button-holder">
                            <b-row align-h="center">
                                <b-col cols="2">
                                    <b-button id="submitButton" style="color: white; background-color: green"
                                              class="submit-button"
                                              type="submit" @click="submit"
                                              variant="primary" :disabled="!canSubmit">Submit
                                    </b-button>
                                </b-col>
                                <b-col cols="2">
                                    <b-button style="color: white; background-color: green" class="cancel-button"
                                              type="cancel" @click="cancel"
                                              variant="primary">Cancel
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-container>
            </b-container>
        </b-container>
    </b-container>


</template>
<script>

import swal from 'sweetalert';

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

    export default {
        data() {
            return {
                errors: [],
                requiredText: "*Required",
                contactName: '',
                contactTitle: '',
                telephoneNumber: '',
                contactTelephoneNumber: '',
                contactEmail: '',
                ownerName: '',
                ownerTelephoneNumber: '',
                ownerEmail: '',
                businessName: '',
                businessAddress: '',
                wasteProvider: '',
                waterSupplySource: '',
                wiesSelected: '',
                trackableWaterMeter: '',
                onSiteBottling: '',
                renewableEnergy: '',
                renewableEnergySelected: [],
                renewableEnergyOptions: ["Solar (at Winery)", "Solar (at Vineyard)", "Geothermal", "Wind", "Microturbine"],
                evChargingStations: '',
                environmentalCertifications: [],
                environmentalCertificationsOptions: ["CCSW", "LEED", "Organic", "Demeter Biodynamic"],
                yesNoOptions: ["Yes", "No"],
                featuresSelected: [],
                featuresOptions: ["Barrel cellar", "Caves", "On Site Bottling", "Winery Tasting Room", "Offsite Tasting Room"
                    , "Onsite Kitchen", "Tom Beard or equivalent barrel machine"],
                wasteWaterSelected: [],
                wasteWaterTreatmentOptions: ["Pond(s)", "Leach", "Packaged treatment system", "Hold and Haul"],
                isSubmitted: true,
                county: null,
              countyMap: [{text: "", value: null},
                  {text: "Napa", value: "28"},
                  {text: "Lake", value: "17"},
                  {text: "Marin", value: "21"},
                {text: "Mendocino", value: "23"},
                {text: "Sonoma", value: "49"},
                {text: "Solano", value: "48"}],
              accountantName: '',
              accountantEmail: '',
              communicationsContact: '',
              communicationsContactEmail: ''
            }
        },
        computed: {
            validateBusinessName: function () {
                let isValid = this.businessName !== "Business Name" && this.businessName !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateBusinessAddress: function () {
                let isValid = this.businessAddress !== "Business Address" && this.businessAddress !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactName: function () {
                let isValid = this.contactName !== "Contact Name" && this.contactName !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactTelephoneNumber: function () {
                let isValid = this.contactTelephoneNumber !== "Telephone" && this.contactTelephoneNumber !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactEmail: function () {
                let isValid = this.validateEmailAddress(this.contactEmail);
                console.log("Email Address valid: " + isValid);
                return isValid;
            },
            canSubmit: function () {
                return this.validateContactEmail && this.validateContactTelephoneNumber
                    && this.validateContactName && this.validateBusinessAddress && this.validateBusinessName
                    && this.isFieldValid(this.accountantName, "Accountant Name")
                    && this.validateEmailAddress(this.accountantEmail, "Accountant Name")
                    && this.isFieldValid(this.ownerName, "Owner/Leadership Name")
                    && this.isFieldValid(this.ownerEmail, "Owner/Leadership Email")
                    && this.isFieldValid(this.county, "County");
            }
        },

        methods: {
            cancel: function () {
                alert('cancel');
            },
            validateEmail: function (mail) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return (true)
                }
                alert("You have entered an invalid email address!")
                return (false)
            },
            validateEmailAddress: function (email) {
                //let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return emailRegex.test(String(email).toLowerCase());
            },
            isFieldValid: function (fieldValue, defaultValue) {
                console.log(Object.keys(fieldValue));
                return fieldValue !== defaultValue && fieldValue !== "";
            }, validateForm: function (self, data) {
                return self.validateEmailAddress(data.contactEmail)
                    && self.isFieldValid(data.contactName, "Contact Name")
                    && self.isFieldValid(data.contactTelephoneNumber, "Telephone")
                    && self.isFieldValid(data.contactEmail, "Contact Email")
                    && self.isFieldValid(data.businessName, "Business Name")
                    && self.isFieldValid(data.businessAddress, "Business Address")
                    && self.isFieldValid(data.county, "County")
                    && self.isFieldValid(data.accountantName, "Accountant Name")
                    && self.validateEmailAddress(data.accountantEmail, "Accountant Name")
                    && self.isFieldValid(data.communicationsContact, "Communications/Marketing Contact")
                    && self.validateEmailAddress(data.communicationsContactEmail, "Communications/Marketing Contact")
                    && self.isFieldValid(data.ownerName, "Owner/Leadership Name")
                    && self.isFieldValid(data.ownerEmail, "Owner/Leadership Email")
                    && self.isFieldValid(data.county, "County");

            },
            buildValidationMessage: function () {
                return "Please enter a valid email address.";
            },
            submit: function () {
                event.target.disabled = true;
                let self = this;
                let data = {
                    contactName: this.contactName,
                    telephoneNumber: this.telephoneNumber,
                    contactTelephoneNumber: this.contactTelephoneNumber,
                    contactEmail: this.contactEmail,
                    businessName: this.businessName,
                    businessAddress: this.businessAddress,
                    ownerName: this.ownerName,
                    ownerTelephoneNumber: this.ownerTelephoneNumber,
                    ownerEmail: this.ownerEmail,
                    county: this.county,

                    wasteProvider: this.wasteProvider,
                    waterSupplySource: this.waterSupplySource,
                    wiesSelected: this.wiesSelected,
                    trackableWaterMeter: this.trackableWaterMeter,
                    onSiteBottling: this.onSiteBottling,
                    renewableEnergy: this.renewableEnergy,
                    renewableEnergySelected: this.renewableEnergySelected,
                    evChargingStations: this.evChargingStations,
                    environmentalCertifications: this.environmentalCertifications,
                    featuresSelected: this.featuresSelected,
                    wasteWaterSelected: this.wasteWaterSelected,
                  status: 'PENDING',
                  accountantName: this.accountantName,
                  accountantEmail: this.accountantEmail,
                  communicationsContact: this.communicationsContact,
                  communicationsContactEmail: this.communicationsContactEmail
                };
                swal("THANK YOU", "Your request has been submitted.", "success");
                self.$http.post('account/request', data, {
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(function (response) {
                    console.log(response.data);
                    self.$router.push({path: '/account-requested?orgType=winery'});
                })
                    .catch(function (error) {
                        console.log("Something went really wrong: ", error);
                    });
            }
        }
    }
</script>
<style>
    .invalid-field {
        color: red;
        size: 14px;
        font-style: italic;
    }
</style>
